module.exports = __webpack_public_path__ + "media/images/hero_images/security-800-98f19b28cb65a23da3221b38f8f20fc7.png";